import { useState, useEffect } from 'react';
import { collection, query, onSnapshot } from 'firebase/firestore';
import { db } from '../config/firebaseConfig';

export interface Category {
  id: string;
  name: string;
  description?: string;
  order: number;
  isActive: boolean;
  createdAt: any;
  updatedAt: any;
}

export const useCategories = () => {
  const [categories, setCategories] = useState<Category[]>([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    try {
      const categoriesRef = collection(db, 'published_categories');
      // Simple query without compound filters to avoid index requirements
      const q = query(categoriesRef);

      const unsubscribe = onSnapshot(
        q,
        (snapshot) => {
          // Filter and sort in JavaScript instead of Firestore
          const categoriesData = snapshot.docs
            .map((doc) => ({
              id: doc.id,
              ...doc.data(),
            })) as Category[];

          // Filter only active categories and sort by order, then by name
          const activeCategories = categoriesData
            .filter(cat => cat.isActive === true)
            .sort((a, b) => {
              if (a.order !== b.order) {
                return a.order - b.order;
              }
              return a.name.localeCompare(b.name);
            });

          setCategories(activeCategories);
          setLoading(false);
          setError(null);
        },
        (err) => {
          console.error('Error fetching categories:', err);
          setError('Failed to load categories');
          setLoading(false);
        }
      );

      return () => unsubscribe();
    } catch (err) {
      console.error('Error setting up categories listener:', err);
      setError('Failed to load categories');
      setLoading(false);
    }
  }, []);

  return { categories, loading, error };
};
